module.exports = {
  en: {
    common: {
      ok: "OK",
      all: "All",
      deny: "Deny",
      edit: "Edit",
      name: "Name",
      save: "Save",
      year: "{{year}}",
      allow: "Allow",
      agree: "Agree",
      email: "Email",
      error: "Error",
      terms: "{{service}} Terms of Service",
      agreed: "Agreed",
      cancel: "Cancel",
      delete: "Delete",
      select: "Select",
      loading: "Loading...",
      profile: "Profile",
      signout: "Sign out",
      editItem: "Edit {{edit}}",
      nameKana: "Katakana/Pronunciation",
      fullname: "Name",
      lastName: "Last Name",
      language: "Language",
      lessThan: "<{{less}}",
      moreThan: ">{{more}}",
      newEmail: "New Email Address",
      optional: "(optional)",
      password: "Password",
      security: "Security",
      username: "Username",
      yearsOne: "{{count}} year",
      firstName: "First Name",
      backToHome: "Back to Homepage",
      yearsOther: "{{count}} years",
      connections: "Connections Management",
      newPassword: "New Password",
      currentEmail: "Current Email Address",
      fullnameKana: "Name (Katakana)",
      lastNameKana: "Katakana/Pronunciation (Last Name)",
      primaryEmail: "Primary Email Address",
      firstNameKana: "Katakana/Pronunciation (First Name)",
      notFoundTitle: "Page not found",
      oauthProfiles: "External Integration Settings",
      organizations: "Organizations",
      passwordError: "Password is incorrect.",
      privacyPolicy: "Privacy Policy",
      employmentType: "Employment",
      graduationYear: "Graduation Year",
      currentPassword: "Current Password",
      termsFetchError:
        "Failed to load the consent document. Processing cannot continue.",
      employmentStudent: "Student",
      termsNotAvailable:
        "The consent document is unavailable. Processing cannot continue.",
      highschoolStudent: "High School",
      sessionManagement: "Session Management",
      yearsOfExperience: "Experience",
      confirmNewPassword: "Confirm New Password",
      employmentFulltime: "Fulltime",
      employmentFreelance: "Freelance",
      notFoundDescription:
        "Sorry, we are not able to find what you were looking for.",
      employmentUnemployed: "Unemployed",
      termsDocumentFetchError: "Failed to load the consent document.",
      primaryEmailDescription:
        "This email will receive Track ID related correspondence.",
      emailAlreadyConnectedError: "This email is already used by the other user"
    }
  },
  ja: {
    common: {
      ok: "OK",
      all: "全て",
      deny: "拒否する",
      edit: "変更する",
      name: "名前",
      save: "保存する",
      year: "{{year}}年",
      allow: "承認する",
      agree: "同意する",
      email: "メールアドレス",
      error: "エラー",
      terms: "{{service}} 利用規約",
      agreed: "同意済み",
      cancel: "キャンセル",
      delete: "削除する",
      select: "選択",
      loading: "読み込み中...",
      profile: "プロフィール",
      signout: "サインアウト",
      editItem: "{{edit}}を変更する",
      nameKana: "カタカナ",
      fullname: "お名前（漢字）",
      lastName: "姓",
      language: "言語",
      lessThan: "<{{less}}",
      moreThan: "{{more}}以上",
      newEmail: "新しいメールアドレス",
      optional: "（任意）",
      password: "パスワード",
      security: "セキュリティ",
      username: "ユーザー",
      yearsOne: "{{count}}年",
      firstName: "名",
      backToHome: "ホームページに戻る",
      yearsOther: "{{count}}年",
      connections: "接続情報の管理",
      newPassword: "新パスワード",
      currentEmail: "現在のメールアドレス",
      fullnameKana: "お名前（カタカナ）",
      lastNameKana: "カタカナ（姓）",
      primaryEmail: "プライマリメールアドレス",
      firstNameKana: "カタカナ（名）",
      notFoundTitle: "ページが見つかりません",
      oauthProfiles: "外部連携設定",
      organizations: "組織",
      passwordError: "パスワードが間違っています。",
      privacyPolicy: "プライバシーポリシー",
      employmentType: "就業状況",
      graduationYear: "卒業見込み",
      currentPassword: "現在パスワード",
      termsFetchError: "同意文書の取得に失敗したため、処理を続行できません。",
      employmentStudent: "在学中",
      termsNotAvailable: "同意文書が存在しないため、処理を続行できません。",
      highschoolStudent: "高校生",
      sessionManagement: "セッション管理",
      yearsOfExperience: "実務経験年数",
      confirmNewPassword: "新パスワード(確認)",
      employmentFulltime: "在籍中（正社員）",
      employmentFreelance: "在籍中（フリーランス)",
      notFoundDescription:
        "申し訳ありませんが、お探しのページが見つかりませんでした。",
      employmentUnemployed: "離職中",
      termsDocumentFetchError: "同意文書の取得に失敗しました",
      primaryEmailDescription: "Track IDの案内を受け取るメールアドレスです。",
      emailAlreadyConnectedError: "このメールアドレスは既に使用されています"
    }
  }
};
